import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { AdminEmployee } from "../../Objects/AdminEmployee/AdminEmployee"
import { PostRequest, PutRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useTranslation } from "react-i18next"

export const useSaveAdminEmployee = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleSaveAdminEmployee = async (employee: AdminEmployee, permissions: string[], onSuccess: () => void) => {
    enableLoad()

    try {
      const isEdit = employee.adminEmployeeId > 0

      const response = isEdit
        ? await PutRequest(
            API_ROUTES.ADMIN_EMPLOYEE.PUT(employee.adminEmployeeId),
            {
              name: employee.name,
              email: employee.email,
              status: employee.status,
            },
            ERequestType.Admin,
          )
        : await PostRequest(
            API_ROUTES.ADMIN_EMPLOYEE.CREATE,
            {
              username: employee.username,
              password: employee.password,
              name: employee.name,
              email: employee.email,
              permissions,
            },
            ERequestType.Admin,
          )

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleSaveAdminEmployee }
}
